import { injectCpmsBoInvoiceApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-invoice.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoInvoiceApi = injectCpmsBoInvoiceApi(baseApi);

export const {
  useLazyCpmsBoGetInvoicePdfQuery,
  useCpmsBoGetInvoiceQuery,
  useCpmsBoGetInvoicesPaginatedQuery,
} = cpmsBoInvoiceApi;
